"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleModifierClassNames = exports.handleInitialClassNames = exports.handleComponentAndChildClassNames = exports.formatKeyName = exports.cleanBaseName = void 0;
var _constants = require("../../constants");
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var formatKeyName = exports.formatKeyName = function formatKeyName(name, nameSplit) {
  var formattedName = name;
  if (nameSplit) {
    var splittedPascalCase = formattedName.replace(/([a-z])([A-Z])/g, '$1_$2');
    formattedName = splittedPascalCase;
  }
  var splittedAndUppercasedTerms = formattedName.replace(/-/gi, '_').toUpperCase();
  formattedName = splittedAndUppercasedTerms;
  return formattedName;
};
var cleanBaseName = exports.cleanBaseName = function cleanBaseName(name) {
  return name.replace(/-/gi, '_').replace(/Cozy__/, '');
};
var handleModifierClassNames = exports.handleModifierClassNames = function handleModifierClassNames(_ref) {
  var modifiers = _ref.modifiers,
    keyName = _ref.keyName,
    generatedClassName = _ref.generatedClassName;
  return modifiers.reduce(function (generatedClassNameWithModifier, modifier) {
    var currentKeyName = "".concat(keyName, "_").concat(formatKeyName(modifier));
    var currentGeneratedClassName = "".concat(generatedClassName, "--").concat(modifier);
    return _objectSpread(_objectSpread({}, generatedClassNameWithModifier), {}, _defineProperty({}, currentKeyName, currentGeneratedClassName));
  }, {});
};
var handleInitialClassNames = exports.handleInitialClassNames = function handleInitialClassNames(_ref2) {
  var component = _ref2.component,
    componentKeySplit = _ref2.componentKeySplit;
  if (component.includes(_constants.COZY_BASE_CLASSNAME)) {
    return {
      initialKeyName: formatKeyName(cleanBaseName(component), componentKeySplit),
      initialComponentName: component
    };
  }
  return {
    initialKeyName: formatKeyName(component, componentKeySplit),
    initialComponentName: "".concat(_constants.COZY_BASE_CLASSNAME).concat(component)
  };
};
var handleComponentAndChildClassNames = exports.handleComponentAndChildClassNames = function handleComponentAndChildClassNames(_ref3) {
  var child = _ref3.child,
    component = _ref3.component,
    initialComponentName = _ref3.initialComponentName,
    initialKeyName = _ref3.initialKeyName,
    childKeySplit = _ref3.childKeySplit;
  if (child) {
    return {
      keyName: "".concat(initialKeyName).concat(component && '_').concat(formatKeyName(child, childKeySplit)),
      generatedClassName: "".concat(initialComponentName).concat(component && '-').concat(child)
    };
  }
  return {
    keyName: initialKeyName,
    generatedClassName: "".concat(initialComponentName)
  };
};